export default {
  NODE_ENV: process.env.NODE_ENV,
  WEB_PLUGIN_VERSION: process.env.WEB_PLUGIN_VERSION,
  FEATURES: {},
  VARIANT: 'plugin',
  SHOWN_CONTACT_SERVER: true, // TODO: check in lusha-widgets if we can remove this
};
